import { render, staticRenderFns } from "./Parle.vue?vue&type=template&id=68a04658&"
import script from "./Parle.vue?vue&type=script&lang=js&"
export * from "./Parle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports